import { firestore } from "../../config/firebase";
import { doc, updateDoc } from "firebase/firestore";

const updateUser = async (id, obj) => {
  const usersRef = doc(firestore, "users", id);
  await updateDoc(usersRef, obj);
};

export default updateUser;
